import * as React from 'react';

export interface IPresetStakesProps {
    presetStakes: any[];
    maxStake: number;
    isEnabledUI: boolean;
    isFreeTicketAccountTypeSelected: boolean;
    setStake: (stake: number) => void;
    onStakeChaned: () => void;
}

export const PresetStakes: React.FC<IPresetStakesProps> = (props: IPresetStakesProps) => {
    return <div className="d-flex stake-fix">
        {
            props.presetStakes.map((stake, index) => {
                let className = props.isFreeTicketAccountTypeSelected ? "btn btn-primary fix-stake-btn disabled" : "btn btn-primary fix-stake-btn";
                //TODO_FT: Nastudovat classNames funkci pro skladani class
                return <div key={stake} className={className} onClick={() => {
                    if (props.isEnabledUI && !props.isFreeTicketAccountTypeSelected) {
                        if (__IsMTSTipos__ && index === (props.presetStakes.length - 1)) {
                            stake = props.maxStake;
                        }
                        props.setStake(+stake);
                        props.onStakeChaned();
                    }
                }}>{`${stake}${__IsMTSTipos__ && stake !== "MAX" ? " €" : ""}`}</div>
            })
        }
    </div>
}